// Shared framing for the auth pages. Previously these widths lived in a single
// AuthPage that held all three forms in a sliding carousel; now each form is its
// own route, so the framing is the only thing they still share.
export default function AuthCard({ children }) {
  return (
    <div className="flex w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:justify-start">
      <div className="w-full max-w-full md:pl-4 lg:pl-0 xl:max-w-[420px]">
        {children}
      </div>
    </div>
  );
}
